/*
 * @Author: songyzh
 * @Date: 2020-07-31 14:28:13
 * @LastEditors: songyzh
 * @LastEditTime: 2021-03-22 11:09:12
 */
import TimeSeq from './time-seq.vue';

export default TimeSeq;
